import { render, staticRenderFns } from "./Page-Student.vue?vue&type=template&id=042b6ef6&"
import script from "./Page-Student.vue?vue&type=script&lang=js&"
export * from "./Page-Student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports